import { fg } from '@atlassian/jira-feature-gating';

const JiraFyRecommendedAssignAgentRelayProvider = {
	get(): boolean {
		return fg('jira-fy-recommended-assign-agent');
	},
};

export default JiraFyRecommendedAssignAgentRelayProvider;
